import { Grid } from 'lucide-react';

export const CUSTOM_SECTIONS = [
  {
    id: "custom",
    title: "Custom Section",
    icon: Grid,
    category: "custom",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No custom sections created yet.",
    editorComponent: "CustomSectionEditor",
    rendererComponent: "CustomSectionRenderer",
    layout: {
      preferredColumn: "main",
      priority: 10,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: [],
    fields: [
      { name: "title", label: "Custom Section Title", type: "text", required: true, placeholder: "e.g. Military Service / Workshops" },
      { name: "content", label: "Section Text Content", type: "textarea", required: true, placeholder: "Write anything here..." }
    ],
    defaultData: { title: "", content: "" }
  }
];
